// @flow

import _ from "lodash";
import fp from "lodash/fp";
import assert from "assert";

export type Divergence = (truth: number, estimate: number) => number;

export function boolToProb(value: boolean): number {
  return value ? 1 : 0;
}

export function isProb(value: mixed): boolean {
  return typeof value === "number" && value >= 0 && value <= 1;
}

export function absoluteDistance(a: number, b: number) {
  return Math.abs(a - b);
}

export function zeroOneError(truth: number, estimate: number) {
  if (estimate === 0.5) {
    return 0.5;
  } else {
    return ((truth > 0.5) === (estimate > 0.5)) ? 0 : 1; // prettier-ignore
  }
}

export function isPositiveInteger(num: any): boolean {
  const number = Number(num);
  return _.isInteger(number) && number > 0;
}

export function weightedSum(
  values: Array<number>,
  weights: Array<number>
): number {
  assert.ok(
    values.length === weights.length,
    "Number of values must equal number of weights"
  );
  return _.sum(_.zip(values, weights).map(([v, w]) => v * w));
}

// Exponential moving average
export function ema(xs: Array<number>, alpha: number) {
  let x0 = null;
  return xs.map(x => {
    const x1 = x0 === null ? x : x0 + alpha * (x - x0);
    x0 = x1;
    return x1;
  });
}

export function bidirectionalEma(xs: Array<number>, alpha: number) {
  const emaForward = ema(xs, alpha);
  const emaBackward = fp.reverse(ema(fp.reverse(xs), alpha));
  return _.zipWith(emaForward, emaBackward, (x, y) => (x + y) / 2);
}



// WEBPACK FOOTER //
// ./src/utils/index.js